import { render, staticRenderFns } from "./related-articles.vue?vue&type=template&id=2ec1345c&scoped=true"
import script from "./related-articles.vue?vue&type=script&lang=js"
export * from "./related-articles.vue?vue&type=script&lang=js"
import style0 from "./related-articles.vue?vue&type=style&index=0&id=2ec1345c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec1345c",
  null
  
)

export default component.exports